module.exports = {
  EthereumMainNetNetworkId: 1,
  EthereumGoerliNetworkId: 5,
  EthereumSepoliaNetworkId: 11155111,
  EthereumMainNetNetworkName: "Ethereum Mainnet",
  EthereumGoerliNetworkName: "Goerli",
  EthereumSepoliaNetworkName: "Sepolia",
};
